import { reportTypes } from '../Common/reportTypes';
import { useSelector } from 'react-redux';
import { selectMetadata } from '../redux/reportSlice';
import GridReport from './GridReport';

function Report() {
    const metadata = useSelector(selectMetadata);
    const { type } = metadata;
    if (type === reportTypes.GRID) {
        return (<GridReport />);
    }
    if (type !== undefined) {
        return (<h2>Report was not found</h2>);
    }
    else {
        return (<h2>Loading...</h2>);
    }
}
export default Report